import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { PriceFilteringRuleAction } from '@cbridge-packages/price-filtering-rules';
import { RulesManagementAction } from '@cbridge-modules/rules-management-page';

export const onUpdatePriceFilteringRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    PriceFilteringRuleAction.update.done,
  ),
  mergeMap(() => {
    return [
      RulesManagementAction.endEditing(undefined),
    ];
  }),
);
